<button class="copy-button">
  <span></span>
  <em (click)="copyToClipboard($event)"
      *ngIf="!isCopied"
      class="fa fa-light fa-copy pointer"
      [tooltip]="toolTipMessageBefore"></em>
  <em (mouseout)="toggleTooltip($event,false)"
      *ngIf="isCopied"
      [delay]="200"
      class="fa fa-light fa-copy pointer"
      [tooltip]="toolTipMessageAfter"></em>
</button>
